var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5251 1.21019C13.2532 0.947734 12.8845 0.800293 12.5 0.800293C12.1155 0.800293 11.7467 0.947734 11.4748 1.21019L1.32482 11.0102C1.06069 11.2742 0.914537 11.6279 0.91784 11.995C0.921144 12.362 1.07364 12.7132 1.34248 12.9727C1.61132 13.2323 1.975 13.3795 2.35519 13.3827C2.73537 13.3859 3.10164 13.2448 3.37512 12.9898L3.79997 12.5796V21.8C3.79997 22.1713 3.95274 22.5274 4.22466 22.7899C4.49659 23.0525 4.8654 23.2 5.24997 23.2H8.14997C8.53453 23.2 8.90335 23.0525 9.17527 22.7899C9.4472 22.5274 9.59997 22.1713 9.59997 21.8V19C9.59997 18.6287 9.75274 18.2726 10.0247 18.01C10.2966 17.7475 10.6654 17.6 11.05 17.6H13.95C14.3345 17.6 14.7033 17.7475 14.9753 18.01C15.2472 18.2726 15.4 18.6287 15.4 19V21.8C15.4 22.1713 15.5527 22.5274 15.8247 22.7899C16.0966 23.0525 16.4654 23.2 16.85 23.2H19.75C20.1345 23.2 20.5033 23.0525 20.7753 22.7899C21.0472 22.5274 21.2 22.1713 21.2 21.8V12.5796L21.6248 12.9898C21.8983 13.2448 22.2646 13.3859 22.6448 13.3827C23.0249 13.3795 23.3886 13.2323 23.6575 12.9727C23.9263 12.7132 24.0788 12.362 24.0821 11.995C24.0854 11.6279 23.9393 11.2742 23.6751 11.0102L13.5251 1.21019V1.21019Z",
    fill: "#01E69C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2411b7c7c6dcd98fb50521e2d648de43.svg";
export { ForwardRef as ReactComponent };